import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { MessageCircleIcon, ChevronDownIcon } from 'lucide-react';
export function Hero() {
  const scrollToServices = () => {
    document.getElementById('services')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="min-h-screen bg-black flex flex-col items-center justify-center px-4 py-12 relative overflow-hidden" data-id="element-117">
      {/* Animated background grid */}
      <div className="absolute inset-0 opacity-10" data-id="element-118">
        <div className="absolute inset-0" style={{
        backgroundImage: `
            linear-gradient(rgba(252, 211, 77, 0.3) 1px, transparent 1px),
            linear-gradient(90deg, rgba(252, 211, 77, 0.3) 1px, transparent 1px)
          `,
        backgroundSize: '60px 60px'
      }} data-id="element-119" />
      </div>

      {/* Gradient orbs */}
      <div className="absolute top-20 left-10 w-96 h-96 bg-yellow-400/10 rounded-full blur-3xl" data-id="element-120" />
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-yellow-400/10 rounded-full blur-3xl" data-id="element-121" />

      <div className="max-w-4xl mx-auto text-center space-y-8 relative z-10" data-id="element-122">
        <motion.img initial={{
        opacity: 0,
        scale: 0.8
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} src="https://uploadthingy.s3.us-west-1.amazonaws.com/rDDbVYSSWnpEBZ6FKUoh2o/LOGO_BODENOR.png" alt="Bodenor - Bodegas Industriales de Nororiente" className="w-full max-w-2xl mx-auto mb-8 drop-shadow-[0_0_30px_rgba(252,211,77,0.3)]" data-id="element-123" />

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight" data-id="element-124">
          Bodenor: el punto exacto para llegar{' '}
          <span className="text-yellow-400 inline-block" data-id="element-125">más lejos.</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-126">
          Bodenor no es solo un complejo de bodegas. Es el lugar donde tu
          operación logística se vuelve más inteligente. Ubicado en Río Hondo,
          Zacapa, conecta la Ruta al Atlántico con Ciudad de Guatemala y las
          fronteras hacia México, Belice, Honduras y El Salvador.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-4" data-id="element-127">
          <Button variant="primary" onClick={scrollToServices} data-id="element-128">
            Ver servicios
          </Button>
          <Button variant="secondary" href="https://wa.me/50245607548?text=Hola%2C%20estoy%20interesado%20en%20los%20servicios%20de%20Bodenor." data-id="element-129">
            <MessageCircleIcon size={20} data-id="element-130" />
            Escríbenos por WhatsApp
          </Button>
        </motion.div>
      </div>

      <motion.button onClick={scrollToServices} className="absolute bottom-8 left-1/2 -translate-x-1/2 text-yellow-400" aria-label="Scroll down" animate={{
      y: [0, 10, 0]
    }} transition={{
      duration: 1.5,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-131">
        <ChevronDownIcon size={32} data-id="element-132" />
      </motion.button>
    </section>;
}